import { Injectable } from '@angular/core';
import { State, Action, StateContext } from '@ngxs/store';
import { MessageStatus } from '../../models/message-status.model';
import { MessageStatusActions } from './message-status.actions';
import { MappingUtilsService } from 'src/app/services/utils/mapping-utils.service';
import { AlertService } from '../alert/alert.service';
import { LocalizationService } from 'src/app/services/localization/localization.service';
import { MessageStatusService } from '../../services/message-status.service';

export class MessageStatusStateModel {
  public messageStatus: MessageStatus[];
  public error: string;
}

const defaults = {
  messageStatus: [],
  error: ''
};

@State<MessageStatusStateModel>({
  name: 'messageStatus',
  defaults
})
@Injectable()
export class MessageStatusState {

  constructor(
    private alertService: AlertService,
    private localizationService: LocalizationService,
    private messageStatusService: MessageStatusService
  ) { }

  @Action(MessageStatusActions.GetMessageStatus)
  getMessageStatus(ctx: StateContext<MessageStatusStateModel>, { }: MessageStatusActions.GetMessageStatus) {
    return this.messageStatusService.getMessageStatus().subscribe({
      next: (messageStatus: MessageStatus[]) => {
        ctx.dispatch(new MessageStatusActions.GetMessageStatusSuccess(messageStatus));
      },
      error: (error) => {
        ctx.dispatch(new MessageStatusActions.GetMessageStatusFail(error));
      }
    });
  }

  @Action(MessageStatusActions.GetMessageStatusSuccess)
  getMessageStatusSuccess(ctx: StateContext<MessageStatusStateModel>, { messageStatus }: MessageStatusActions.GetMessageStatusSuccess) {
    ctx.patchState({
      messageStatus: messageStatus
    });
  }

  @Action(MessageStatusActions.GetMessageStatusFail)
  getMessageStatusFail(ctx: StateContext<MessageStatusStateModel>, { error }: MessageStatusActions.GetMessageStatusFail) {
    ctx.patchState({
      error: error,
    });
    MappingUtilsService.showError(this.getTitle(), error, this.alertService, this.localizationService);
  }

  private getTitle() {
    return this.localizationService.translate('message-status.title');
  }
}
